// routes
import Iconify from "src/components/iconify/Iconify";
import { paths } from "../../../routes/paths";

// ----------------------------------------------------------------------

const icon = (name: string) => <Iconify icon={name} />;

const ICONS = {
  home: icon("eva:home-outline"),
  platforms: icon("eva:message-circle-outline"),
  newspaper: icon("eva:book-open-outline"),
  trends: icon("eva:radio-button-on-outline"),
  logout: icon("eva:log-out-outline"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      {
        title: "social media",
        path: "dashboard",
        icon: ICONS.home,
        children: [
          { title: "youtube", path: paths.main.youtube },
          { title: "twitter", path: paths.main.twitter },
        ],
      },
      {
        title: "Newspaper",
        path: "dashboard",
        icon: ICONS.home,
        children: [
          { title: "medium", path: paths.main.medium },
          { title: "forbes", path: paths.main.forbes },
          { title: "quartz", path: paths.main.quartz },
          { title: "NYC Times", path: paths.main.NYCTimes },
          { title: "Mercury news", path: paths.main.TheMercuryNews },
        ],
      },
    ],
  },
];
export default navConfig;
